import api from './axiosInstance';

export const getProfitLossReportApi = (params) =>
  api.get('/reports/profit-loss', { params });

export const getExpenseBreakdownReportApi = (params) =>
  api.get('/reports/expense-breakdown', { params });

export const getTimelineReportApi = (params) =>
  api.get('/reports/timeline', { params });

export const getYearOverYearReportApi = () =>
  api.get('/reports/year-over-year');

export const getPlotPerformanceReportApi = (params) =>
  api.get('/reports/plot-performance', { params });
